import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IStatusPanelParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { Context } from '../../../list.interfaces';
import { IStatusPanelAngularComp } from './status-bar-grid.interface';

@Component({
  selector: 'etoh-status-bar-grid',
  templateUrl: './status-bar-grid.component.html',
  styleUrls: ['./status-bar-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FlexLayoutModule],
})
export class StatusBarGridComponent implements IStatusPanelAngularComp {
  private params: IStatusPanelParams;

  private selectedData$ = new BehaviorSubject<any[]>([]);
  $selectedData = toSignal(this.selectedData$.asObservable());

  get context(): Context {
    return this.params.context;
  }

  agInit(params: IStatusPanelParams): void {
    this.params = params;
  }

  onClick(): void {
    console.log('params', this.params);
    alert('Selected Row Count: ' + this.params.api.getSelectedRows().length);
  }

  update(data: any[]) {
    this.selectedData$.next(data);
  }
}
